import { en } from './en';
import { it } from './it';
import { zh } from './zh';

export const dictionaries = { en, it, zh } as const;

export { en, it, zh };
